import './Services.css'

const Services = () => {
  const services = [
    {
      title: 'Personalized Legacy Book',
      description: 'A beautiful, custom heirloom book — your wishes, memories, and love letters gathered in one keepsake your family can hold.',
    },
    {
      title: 'Document Organization',
      description: 'Medical history, important papers, and end-of-life wishes — organized with care so nothing important is ever lost or overlooked.',
    },
    {
      title: 'Love Letters & Messages',
      description: 'Heartfelt words for the people you love, preserved for the moments when your voice matters most.',
    },
    {
      title: 'Protective Pouch',
      description: 'Everything in one place — a tangible legacy of preparation that brings calm when your family needs it most.',
    },
    {
      title: 'Family Coordination',
      description: 'When it matters most, your family has clarity. No searching through drawers. No second-guessing. Just peace.',
    },
    {
      title: 'Guided Preparation',
      description: 'Gentle, step-by-step guidance through the process — because difficult conversations deserve a compassionate hand to hold.',
    },
  ]

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">How We Help</span>
          <h2>What You Receive</h2>
          <p className="section-subtitle">
            Everything designed to bring order, clarity, and comfort — so your family
            never has to wonder what you would have wanted.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card fade-in-up">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
